import { Component, Fragment } from 'react';
import { logger } from '../../../helpers/logger';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logger.error(`ERROR:`, error);
    logger.error(`ERROR INFO:`, info);
  }

  render() {
    const { hasError } = this.state;
    const { children, componentId } = this.props;

    if (hasError) {
      logger.error(`There has been an error in ${componentId} Component`);
      return <Fragment />;
    }

    return children;
  }
}

export default ErrorBoundary;
